/* eslint-disable react/jsx-no-bind */
import { Settings, Search, Refresh } from '@mui/icons-material';
import {
  Box,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem as DropdownItem,
  Paper,
  IconButton,
  Menu,
  CardContent,
  Card,
  TablePagination,
  Modal,
  useTheme,
  Typography,
  MenuItem,
  FormControl,
  Grid,
  Divider,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import { useNavigate } from 'react-router-dom';

import 'react-quill/dist/quill.snow.css';

import { tokens } from '../../theme';
import { getCurrentISTDate, formatToIST } from '../../utils/dateFormatter';
import logger from '../../utils/logger';

const options = ['Technical', 'Installation', 'General'];

const priorityList = ['Urgent', 'Medium', 'High'];
// const initialData = [
//   {
//     id: 1,
//     ticketNo: "202401-0001",
//     name: "dfggd",
//     email: "chalamallan3@gmail.com",
//     category: "Technical",
//     subject: "fsdfdsf",
//     description:
//       "Lorem ipsum dolor sit amet, consectetur adipisicing elit.Obcaecati consequatur nihil dolorum rerum minus illo voluptate,perspiciatis necessitatibus ullam in, voluptatibus quaerat, adaccusamus. Voluptates ut architecto ea autem distinctio.",
//     status: "Resolved",
//     priority: "Urgent",
//     creationDate: "15-01-2024 10:21:22",
//   },
//   {
//     id: 2,
//     ticketNo: "202401-0002",
//     name: "dfggd",
//     email: "chalamallan3@gmail.com",
//     category: "Technical",
//     subject: "fsdfdsf",
//     description:
//       "Lorem ipsum dolor sit amet, consectetur adipisicing elit.Obcaecati consequatur nihil dolorum rerum minus illo voluptate,perspiciatis necessitatibus ullam in, voluptatibus quaerat, adaccusamus. Voluptates ut architecto ea autem distinctio.",
//     status: "Resolved",
//     priority: "Medium",
//     creationDate: "15-01-2024 14:57:34",
//   },
//   {
//     id: 3,
//     ticketNo: "202401-0003",
//     name: "dasd",
//     email: "chalamallan3@gmail.com",
//     category: "Technical",
//     subject: "werwetrw",
//     description:
//       "Lorem ipsum dolor sit amet, consectetur adipisicing elit.Obcaecati consequatur nihil dolorum rerum minus illo voluptate,perspiciatis necessitatibus ullam in, voluptatibus quaerat, adaccusamus. Voluptates ut architecto ea autem distinctio.",
//     status: "New Ticket",
//     priority: "Medium",
//     creationDate: "16-01-2024 12:17:57",
//   },
//   {
//     id: 4,
//     ticketNo: "202401-0004",
//     name: "Amit",
//     email: "chalamallan3@gmail.com",
//     category: "Installation",
//     subject: "Regarding Installation",
//     description:
//       "Lorem ipsum dolor sit amet, consectetur adipisicing elit.Obcaecati consequatur nihil dolorum rerum minus illo voluptate,perspiciatis necessitatibus ullam in, voluptatibus quaerat, adaccusamus. Voluptates ut architecto ea autem distinctio.",
//     status: "Resolved",
//     priority: "High",
//     creationDate: "21-01-2024 19:03:19",
//   },
//   {
//     id: 5,
//     ticketNo: "202402-0005",
//     name: "John Doe",
//     email: "chalamallan3@gmail.com",
//     category: "Installation",
//     subject: "Installation Issue",
//     description:
//       "Lorem ipsum dolor sit amet, consectetur adipisicing elit.Obcaecati consequatur nihil dolorum rerum minus illo voluptate,perspiciatis necessitatibus ullam in, voluptatibus quaerat, adaccusamus. Voluptates ut architecto ea autem distinctio.",
//     status: "Resolved",
//     priority: "High",
//     creationDate: "19-02-2024 21:52:44",
//   },
//   {
//     id: 6,
//     ticketNo: "202401-0006",
//     name: "dfggd",
//     email: "chalamallan3@gmail.com",
//     category: "Technical",
//     subject: "fsdfdsf",
//     description:
//       "Lorem ipsum dolor sit amet, consectetur adipisicing elit.Obcaecati consequatur nihil dolorum rerum minus illo voluptate,perspiciatis necessitatibus ullam in, voluptatibus quaerat, adaccusamus. Voluptates ut architecto ea autem distinctio.",
//     status: "Resolved",
//     priority: "Urgent",
//     creationDate: "15-01-2024 10:21:22",
//   },
//   {
//     id: 7,
//     ticketNo: "202401-0007",
//     name: "dfggd",
//     email: "chalamallan3@gmail.com",
//     category: "Technical",
//     subject: "fsdfdsf",
//     description:
//       "Lorem ipsum dolor sit amet, consectetur adipisicing elit.Obcaecati consequatur nihil dolorum rerum minus illo voluptate,perspiciatis necessitatibus ullam in, voluptatibus quaerat, adaccusamus. Voluptates ut architecto ea autem distinctio.",
//     status: "Resolved",
//     priority: "Medium",
//     creationDate: "15-01-2024 14:57:34",
//   },
//   {
//     id: 8,
//     ticketNo: "202401-0008",
//     name: "dasd",
//     email: "chalamallan3@gmail.com",
//     category: "Technical",
//     subject: "werwetrw",
//     description:
//       "Lorem ipsum dolor sit amet, consectetur adipisicing elit.Obcaecati consequatur nihil dolorum rerum minus illo voluptate,perspiciatis necessitatibus ullam in, voluptatibus quaerat, adaccusamus. Voluptates ut architecto ea autem distinctio.",
//     status: "New Ticket",
//     priority: "Medium",
//     creationDate: "16-01-2024 12:17:57",
//   },
// ];

const statusDtata = [
  { label: 'New Ticket' },
  { label: 'In Progress' },
  { label: 'Resolved' },
];

const Tickets = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [errors, setErrors] = useState({
    id: '',

    name: '',
    email: '',
    category: '',
    subject: '',
    description: '',
    attachment: null,
    priority: '',
    status: '',
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [newTicket, setNewTicket] = useState({
    id: '',
    ticketNo: '',
    name: '',
    email: '',
    category: '',
    description: '',
    subject: '',
    status: '',
    attachment: '',
    priority: '',
    creationDate: '',
  });

  const navigate = useNavigate();

  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [originalData, setOriginalData] = useState([]);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const fetchTickets = async () => {
    try {
      const response = await fetch('http://localhost:3031/tickets');
      const result = await response.json();
      setData(result);
      setOriginalData(result);
    } catch (error) {
      logger.error('Error fetching Tickets:', error);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  const handleSearch = () => {
    const filteredData = originalData.filter(
      (item) =>
        search === '' || item.name.toLowerCase().includes(search.toLowerCase()),
    );
    setData(filteredData);
  };

  const handleReset = () => {
    setSearch('');
    setData(originalData);
  };

  const handleModalReset = () => {
    setModalOpen(false);
  };

  const handleMenuOpen = (event, row) => {
    setMenuAnchor(event.currentTarget);
    setSelectedTicket(row);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleModalOpen = (editMode = false) => {
    setIsEditMode(editMode);
    if (editMode && selectedTicket) {
      setNewTicket(selectedTicket);
    } else {
      setNewTicket({
        ticketNo: '',
        name: '',
        email: '',
        category: '',
        description: '',
        subject: '',
        status: '',
        attachment: '',
        priority: '',
        creationDate: '',
      });
    }
    setModalOpen(true);
  };

  const handleViewDetails = (ticket, Id) => {
    navigate(`/tickets/${Id}`, { state: { ticket } });
  };

  const validateInputs = () => {
    let valid = true;
    const newErrors = {
      id: '',
      name: '',
      email: '',
      category: '',
      subject: '',
      description: '',
      attachment: null,
      priority: '',
      status: '',
    };

    if (!newTicket.name.trim()) {
      newErrors.name = 'Name is required.';
      valid = false;
    }
    if (newTicket.name.trim().length < 3 && newTicket.name.trim().length > 0) {
      newErrors.name = 'Minimum length must be 3';
      valid = false;
    }
    if (!newTicket.email.trim() || !/\S+@\S+\.\S+/.test(newTicket.email)) {
      newErrors.email = 'A valid email is required.';
      valid = false;
    }
    if (!newTicket.category) {
      newErrors.category = 'Category is required.';
      valid = false;
    }
    if (!newTicket.subject.trim()) {
      newErrors.subject = 'Subject is required.';
      valid = false;
    }
    if (!newTicket.description.trim()) {
      newErrors.description = 'Description is required.';
      valid = false;
    }
    if (!newTicket.priority) {
      newErrors.priority = 'Priority is required.';
      valid = false;
    }
    // if (!newTicket.attachment) {
    //   newErrors.attachment = "Attachment is required.";
    //   valid = false;
    // }

    setErrors(newErrors);
    return valid;
  };

  const handleModalClose = () => {
    setModalOpen(false);
    handleModalReset();
    setErrors({});
    setSelectedTicket(null);
  };

  const handleAddTicket = async () => {
    if (validateInputs()) {
      try {
        const updatedTicket = {
          ...newTicket,
          status: 'New Ticket',
          ticketNo: '202401-0001',
          creationDate: getCurrentISTDate(),
        };
        const response = await fetch('http://localhost:3031/tickets', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedTicket),
        });
        if (response.ok) {
          fetchTickets();
          handleModalClose();
        }
      } catch (error) {
        logger.error('Error adding Tickets:', error);
      }
    }
  };

  const handleEditTicket = async () => {
    if (validateInputs()) {
      try {
        const response = await fetch(
          `http://localhost:3031/tickets/${selectedTicket.id}`,
          {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(newTicket),
          },
        );

        if (response.ok) {
          fetchTickets();
          handleModalClose();
        } else {
          logger.error('Failed to update Tickets', await response.text());
        }
      } catch (error) {
        logger.error('Error editing Tickets:', error);
      }
    }
  };

  const handleDelete = async () => {
    try {
      const response = await fetch(
        `http://localhost:3031/tickets/${selectedTicket.id}`,
        {
          method: 'DELETE',
        },
      );
      if (response.ok) {
        fetchTickets();
        handleMenuClose();
      }
    } catch (error) {
      logger.error('Error deleting Tickets', error);
    }
  };
  return (
    <>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingLeft: 4,
              paddingTop: 2,
              paddingBottom: 0,
            }}
          >
            <h3>Tickets</h3>
          </Box>
          <Divider />
          <Box sx={{ padding: 4 }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 3,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  gap: 2,
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  overflowX: 'auto',
                  minWidth: 'fit-content',
                  padding: '12px 16px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '12px',
                  border: '1px solid #e9ecef',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                  '&::-webkit-scrollbar': {
                    height: '6px',
                  },
                  '&::-webkit-scrollbar-track': {
                    backgroundColor: '#f1f1f1',
                    borderRadius: '3px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: colors.swiftcarry[100],
                    borderRadius: '3px',
                  },
                }}
              >
                <TextField
                  label="Search"
                  variant="outlined"
                  size="small"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      handleSearch();
                    }
                  }}
                  sx={{
                    minWidth: 200,
                    '& .MuiOutlinedInput-root': {
                      height: '36px',
                      borderRadius: '8px',
                      backgroundColor: 'white',
                      '&.Mui-focused fieldset': {
                        borderColor: colors.swiftcarry[100],
                        borderWidth: '2px',
                      },
                      '&:hover fieldset': {
                        borderColor: colors.swiftcarry[100],
                      },
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: '13px',
                      color: 'gray',
                      '&.Mui-focused': {
                        color: colors.swiftcarry[100],
                      },
                    },
                  }}
                />
                <IconButton
                  onClick={handleSearch}
                  sx={{
                    bgcolor: colors.swiftcarry[100],
                    color: 'white',
                    width: '50px',
                    height: '50px',
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0, 201, 150, 0.3)',
                    '&:hover': {
                      bgcolor: colors.swiftcarry[100],
                      transform: 'translateY(-1px)',
                      boxShadow: '0 4px 12px rgba(0, 201, 150, 0.4)',
                    },
                    transition: 'all 0.2s ease',
                  }}
                >
                  <Search fontSize="medium" />
                </IconButton>
                <IconButton
                  onClick={handleReset}
                  sx={{
                    border: `2px solid ${colors.swiftcarry[100]}`,
                    color: colors.swiftcarry[100],
                    backgroundColor: 'white',
                    width: '50px',
                    height: '50px',
                    borderRadius: '12px',
                    '&:hover': {
                      borderColor: colors.swiftcarry[100],
                      backgroundColor: `${colors.swiftcarry[100]}10`,
                      transform: 'translateY(-1px)',
                    },
                    transition: 'all 0.2s ease',
                  }}
                >
                  <Refresh fontSize="medium" />
                </IconButton>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleModalOpen(false)}
                  sx={{
                    bgcolor: colors.swiftcarry[100],
                    '&:hover': {
                      bgcolor: colors.swiftcarry[100],
                    },
                  }}
                >
                  Add
                </Button>
              </Box>
            </Box>

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: 'bold' }}>
                      Ticket No
                    </TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Name</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>
                      Category
                    </TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>
                      Subject
                    </TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>
                      Priority
                    </TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>
                      Creation Date
                    </TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow key={row.id}>
                        <TableCell>{row.ticketNo}</TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>{row.category}</TableCell>
                        <TableCell>{row.subject}</TableCell>
                        <TableCell>
                          <span
                            style={{
                              padding: '4px 8px',
                              backgroundColor:
                                row.status === 'Resolved'
                                  ? 'green'
                                  : row.status === 'New Ticket'
                                    ? 'orange'
                                    : 'gray',
                              color: 'white',
                              borderRadius: '4px',
                            }}
                          >
                            {row.status}
                          </span>
                        </TableCell>
                        <TableCell>
                          <span
                            style={{
                              padding: '4px 8px',
                              backgroundColor:
                                row.priority === 'Urgent'
                                  ? 'red'
                                  : row.priority === 'High'
                                    ? 'orange'
                                    : 'blue',
                              color: 'white',
                              borderRadius: '4px',
                            }}
                          >
                            {row.priority}
                          </span>
                        </TableCell>
                        <TableCell>{row.creationDate ? formatToIST(row.creationDate) : 'N/A'}</TableCell>
                        <TableCell>
                          <IconButton
                            onClick={(event) => handleMenuOpen(event, row)}
                          >
                            <Settings />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 50, 100]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                '& .MuiToolbar-root': {
                  display: 'flex',
                  width: '500px',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                },
                '& .MuiTablePagination-selectLabel': {
                  marginBottom: '0px',
                },
                '& .MuiTablePagination-displayedRows': {
                  marginBottom: '0px',
                },
                '& .MuiTablePagination-actions': {
                  display: 'flex',
                  alignItems: 'center',
                  gap: '2px',
                },
                '& .MuiTablePagination-input': {
                  minWidth: '30px',
                },
              }}
            />
            <Menu
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={handleMenuClose}
            >
              <DropdownItem
                onClick={() => {
                  handleViewDetails(selectedTicket, selectedTicket.id);
                  handleMenuClose();
                }}
              >
                View
              </DropdownItem>
              <DropdownItem
                onClick={() => {
                  handleModalOpen(true);
                  handleMenuClose();
                }}
              >
                Edit
              </DropdownItem>
              <DropdownItem onClick={handleDelete}>Delete</DropdownItem>
            </Menu>
          </Box>
        </CardContent>
      </Card>

      <Modal open={modalOpen} onClose={handleModalClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '75%', md: '60%' },
            maxHeight: '90vh',
            bgcolor: 'background.paper',
            boxShadow: 24,
            borderRadius: 2,
            overflowY: 'auto',
            padding: 3,
          }}
        >
          <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
            {isEditMode ? 'Edit Ticket' : 'Create Ticket'}
          </Typography>
          <Paper style={{ padding: '20px', overflow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  variant="outlined"
                  value={newTicket.name}
                  onChange={(e) => {
                    setNewTicket({ ...newTicket, name: e.target.value });
                    setErrors({ ...errors, name: '' });
                  }}
                  error={!!errors.name}
                  helperText={errors.name}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&.Mui-focused fieldset': {
                        borderColor: colors.swiftcarry[100],
                        color: colors.swiftcarry[100],
                      },
                    },
                    '& .MuiInputLabel-root': {
                      color: 'gray',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: colors.swiftcarry[100],
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Email ID"
                  name="email"
                  variant="outlined"
                  value={newTicket.email}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&.Mui-focused fieldset': {
                        borderColor: colors.swiftcarry[100],
                        color: colors.swiftcarry[100],
                      },
                    },
                    '& .MuiInputLabel-root': {
                      color: 'gray',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: colors.swiftcarry[100],
                    },
                  }}
                  onChange={(e) => {
                    setNewTicket({ ...newTicket, email: e.target.value });
                    setErrors({ ...errors, email: '' });
                  }}
                  error={!!errors.email}
                  helperText={errors.email}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <TextField
                    select
                    label="Category"
                    name="Category"
                    value={newTicket.category}
                    onChange={(e) => {
                      setNewTicket({ ...newTicket, category: e.target.value });
                      setErrors({ ...errors, category: '' });
                    }}
                    error={!!errors.category}
                    helperText={errors.category}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                          borderColor: colors.swiftcarry[100],
                          color: colors.swiftcarry[100],
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: 'gray',
                      },
                      '& .MuiInputLabel-root.Mui-focused': {
                        color: colors.swiftcarry[100],
                      },
                    }}
                  >
                    {options.map((category) => (
                      <MenuItem key={category} value={category}>
                        {category}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Subject"
                  name="subject"
                  variant="outlined"
                  value={newTicket.subject}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '&.Mui-focused fieldset': {
                        borderColor: colors.swiftcarry[100],
                        color: colors.swiftcarry[100],
                      },
                    },
                    '& .MuiInputLabel-root': {
                      color: 'gray',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: colors.swiftcarry[100],
                    },
                  }}
                  onChange={(e) => {
                    setNewTicket({ ...newTicket, subject: e.target.value });
                    setErrors({ ...errors, subject: '' });
                  }}
                  error={!!errors.subject}
                  helperText={errors.subject}
                />
              </Grid>

              <Grid item xs={12} mb={6}>
                <Typography variant="h8" gutterBottom></Typography>
                <ReactQuill
                  value={newTicket.description}
                  onChange={(value) => {
                    setNewTicket({ ...newTicket, description: value });
                    setErrors({ ...errors, description: '' });
                  }}
                  theme="snow"
                  style={{
                    height: '200px',
                    marginBottom: '20px',
                  }}
                  placeholder="Ticket Description"
                />
              </Grid>

              <Grid item xs={12} md={isEditMode ? 4 : 6} mt={2}>
                <FormControl fullWidth>
                  <Button
                    variant="contained"
                    component="label"
                    sx={{
                      bgcolor: colors.swiftcarry[100],
                      '&:hover': {
                        bgcolor: colors.swiftcarry[100],
                      },
                    }}
                  >
                    Choose File
                    <input
                      type="file"
                      hidden
                      name="attachment"
                      onChange={(e) => {
                        setNewTicket({
                          ...newTicket,
                          attachment: e.target.files[0],
                        });
                        setErrors({ ...errors, attachment: null });
                      }}
                    />
                  </Button>
                  {newTicket.attachment && (
                    <Typography variant="body2" style={{ marginTop: '5px' }}>
                      {newTicket.attachment.name}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12} md={isEditMode ? 4 : 6}>
                <FormControl fullWidth>
                  <TextField
                    select
                    label="Priority"
                    name="priority"
                    value={newTicket.priority}
                    onChange={(e) => {
                      setNewTicket({ ...newTicket, priority: e.target.value });
                      setErrors({ ...errors, priority: '' });
                    }}
                    error={!!errors.priority}
                    helperText={errors.priority}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                          borderColor: colors.swiftcarry[100],
                          color: colors.swiftcarry[100],
                        },
                      },
                      '& .MuiInputLabel-root': {
                        color: 'gray',
                      },
                      '& .MuiInputLabel-root.Mui-focused': {
                        color: colors.swiftcarry[100],
                      },
                    }}
                  >
                    {priorityList.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </Grid>

              {isEditMode ? (
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <TextField
                      select
                      label="Status"
                      name="status"
                      value={newTicket.status}
                      onChange={(e) =>
                        setNewTicket({ ...newTicket, status: e.target.value })
                      }
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '&.Mui-focused fieldset': {
                            borderColor: colors.swiftcarry[100],
                            color: colors.swiftcarry[100],
                          },
                        },
                        '& .MuiInputLabel-root': {
                          color: 'gray',
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                          color: colors.swiftcarry[100],
                        },
                      }}
                    >
                      {statusDtata.map((option) => (
                        <MenuItem key={option.label} value={option.label}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </FormControl>
                </Grid>
              ) : (
                ''
              )}

              <Grid
                item
                xs={12}
                display="flex"
                justifyContent="flex-end"
                gap={2}
              >
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleModalReset}
                  sx={{
                    borderColor: colors.swiftcarry[100],
                    color: colors.swiftcarry[100],
                    '&:hover': {
                      borderColor: colors.swiftcarry[100],
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={isEditMode ? handleEditTicket : handleAddTicket}
                  sx={{
                    bgcolor: colors.swiftcarry[100],
                    '&:hover': {
                      bgcolor: colors.swiftcarry[100],
                    },
                  }}
                >
                  {isEditMode ? 'Edit Ticket' : 'Create New Ticket'}
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </Modal>
    </>
  );
};

export default Tickets;
